import { createSlice } from '@reduxjs/toolkit';

import { searchKeys } from '../constants';

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        [searchKeys.NUMBER_OF_ROOMS]: 1,
        [searchKeys.ADULTS]: 2,
        [searchKeys.CHILDREN]: 0,
        checkInDay: null,
        checkOutDay: null,
        tempCheckOutDay: null,
        language: null,
        currency: null,
        sortBy: '',
        sortByProperty: '',
        isMultipropertyTrackPrices: '',
        calendarAlert: '',
        isCalendarOpen: false,
        selectedCancellationAndPaymentPolicyData: null,
        initialDate: null,
    },
    reducers: {
        updateSearchKey: (state, { payload }) => {
            state[payload.key] = payload.value;
        },
        setCheckInDay: (state, { payload }) => {
            state.checkInDay = payload.day;
        },
        setCheckOutDay: (state, { payload }) => {
            state.checkOutDay = payload.day;
        },
        setTempCheckOutDay: (state, { payload }) => {
            state.tempCheckOutDay = payload.day;
        },
        setLanguage: (state, { payload }) => {
            state.language = payload.language;
        },
        setCurrency: (state, { payload }) => {
            state.currency = payload.currency;
        },
        setSortBy: (state, { payload }) => {
            state.sortBy = payload.sortBy;
        },
        setSortByProperty: (state, { payload }) => {
            state.sortByProperty = payload.sortByProperty;
        },
        setIsMultipropertyTrackPrices: (state, { payload }) => {
            state.isMultipropertyTrackPrices =
                payload.isMultipropertyTrackPrices;
        },
        setCalendarAlert: (state, { payload }) => {
            state.calendarAlert = payload.msg;
        },
        setCalendarOpen: (state, { payload }) => {
            state.isCalendarOpen = payload.isCalendarOpen;
        },
        setSelectedCancellationAndPaymentPolicyData: (state, { payload }) => {
            state.selectedCancellationAndPaymentPolicyData = payload;
        },
        setAmenitiesData: (state, { payload }) => {
            state.amenitiesData = payload;
        },
        setTermsAndConditionsData: (state, { payload }) => {
            state.setTermsAndConditionsData = payload;
        },
        setInitialDate: (state, { payload }) => {
            state.initialDate = payload?.split('/').reverse().join('-');
        },
        setInitialPrice: (state, { payload }) => {
            state.initialPrice =
                Math.round((payload?.price / payload?.nights) * 100) / 100;
        },
    },
});

export const {
    updateSearchKey,
    setCheckInDay,
    setCheckOutDay,
    setTempCheckOutDay,
    setCurrency,
    setLanguage,
    setSortBy,
    setSortByProperty,
    setIsMultipropertyTrackPrices,
    setCalendarAlert,
    setCalendarOpen,
    setSelectedCancellationAndPaymentPolicyData,
    setAmenitiesData,
    setTermsAndConditionsData,
    setInitialDate,
    setInitialPrice,
    setFirstDay,
} = userSlice.actions;
